import { createContext } from "react";

const RootRouterContext = createContext();
export default RootRouterContext;
